import {Editor} from '@tinymce/tinymce-react';
import {useRef} from 'react';

import {FormControl} from 'components';
import {envConfig} from 'config';

type Props = {
    className?: string;
    value?: string;
    initialValue?: string;
    height?: number;
    label?: string;
    onChange?: (value: string) => void;
}

export const Wysiwyg: React.FC<Props> = ({className, value, initialValue, height = 200, label, onChange}: Props) => {
    const editorRef = useRef(null);

    return (
        <FormControl value={value} label={label} active className={className}>
            {() => (
                <Editor
                    apiKey={envConfig.tinymceKey}
                    initialValue={initialValue}
                    init={{
                        width: '100%',
                        height,
                        menubar: false,
                        convert_urls: false,
                        plugins: [
                            'advlist',
                            'autolink',
                            'lists',
                            'link',
                            'image',
                            'charmap',
                            'preview',
                            'anchor',
                            'searchreplace',
                            'visualblocks',
                            'code',
                            'fullscreen',
                            'insertdatetime',
                            'media',
                            'table',
                            'code',
                            'help',
                            'wordcount'
                        ],
                        toolbar: 'undo redo | formatselect | ' +
                            'bold italic backcolor | alignleft aligncenter ' +
                            'alignright alignjustify | bullist numlist outdent indent | ' +
                            'removeformat',
                        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                    }}
                    onInit={(evt, editor) => editorRef.current = editor}
                    onEditorChange={onChange}
                />
            )}
        </FormControl>
    );
};
